export function noTextOverflow(attributes) {
  if (attributes['&:hover'] === null) {
    attributes['&:hover'] = {}
  }
  return {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    '&:hover': {
      overflow: 'visible',
      opacity: 1,
    },
    ...attributes,
  }
}

export function verticallyCenterText(attributes) {
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    ...attributes,
  }
}



// WEBPACK FOOTER //
// ./src/utils/styleUtils.js